<div class="payment-button d-flex justify-content-center">
  <app-button
    (clickEvent)="pay()"
    [label]="isBig() ? ('BUTTON.PAY_LOAN' | translate) : ('BUTTON.REPAYMENT' | translate)"
    [color]="isBig() ? 'secondary' : 'inline'"
    [size]="isBig() ? 'w100' : 'xSmall'"
    [class.w-100]="isBig()"
    [class.ml-3]="!isBig()"
    [disabled]="isDisabled()"
  />
</div>
